export { default as TransfersPage } from "./transfers-page.vue"
